/* =====================================================================
   mdl-toc.js
   ブログ記事の自動目次 (xWrite 風)
   - 記事内 h2 / h3 を走査して ID 付与
   - 目次 (.mdl-toc) を生成
   - 開閉トグル / smooth scroll / scroll spy
===================================================================== */
(function () {
  'use strict';

  function slugify(text) {
    return (text || '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-぀-ゟ゠-ヿ一-鿿㐀-䶿]/g, '')
      .toLowerCase()
      .slice(0, 80) || 'h-' + Math.random().toString(36).slice(2, 8);
  }

  function ensureUniqueId(el, used) {
    var base = el.id || slugify(el.textContent);
    var id = base;
    var n = 2;
    while (used[id]) { id = base + '-' + n; n++; }
    used[id] = true;
    el.id = id;
    return id;
  }

  function buildToc(toc) {
    var contentSelector = toc.dataset.target || '.mdl-article-blog__content';
    var levels = (toc.dataset.levels || 'h2,h3').split(',').map(function (s) { return s.trim().toLowerCase(); });
    var content = document.querySelector(contentSelector);
    if (window.console) console.log('[mdl-toc] target:', contentSelector, 'found:', !!content);
    if (!content) { toc.hidden = true; return; }

    var headingSelector = levels.join(',');
    var headings = Array.prototype.slice.call(content.querySelectorAll(headingSelector));
    if (window.console) console.log('[mdl-toc] headings:', headings.length, headings);
    if (headings.length < 1) { toc.hidden = true; return; }

    var used = {};
    headings.forEach(function (h) { ensureUniqueId(h, used); });

    var topLevel = levels[0];
    var rootList = document.createElement('ol');
    var currentL1Sublist = null;

    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'mdl-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();

      li.appendChild(a);

      if (h.tagName.toLowerCase() === topLevel) {
        rootList.appendChild(li);
        currentL1Sublist = null;
      } else {
        if (!currentL1Sublist) {
          var lastTopLi = rootList.lastElementChild;
          if (!lastTopLi) {
            rootList.appendChild(li);
            return;
          }
          currentL1Sublist = document.createElement('ol');
          lastTopLi.appendChild(currentL1Sublist);
        }
        currentL1Sublist.appendChild(li);
      }
    });

    var body = toc.querySelector('.mdl-toc__body');
    if (body) {
      body.innerHTML = '';
      body.appendChild(rootList);
    }

    /* 最初の h2 の直前に目次を移動 */
    var firstTopHeading = content.querySelector(topLevel);
    if (firstTopHeading && firstTopHeading.parentNode) {
      firstTopHeading.parentNode.insertBefore(toc, firstTopHeading);
    }

    setupToggle(toc);
    setupSmoothScroll(toc);
    setupScrollSpy(toc, headings);
  }

  function setupToggle(toc) {
    var head = toc.querySelector('.mdl-toc__head');
    if (!head) return;
    head.addEventListener('click', function () {
      var expanded = toc.getAttribute('aria-expanded') !== 'false';
      toc.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  function setupSmoothScroll(toc) {
    toc.addEventListener('click', function (e) {
      var a = e.target.closest('a.mdl-toc__link');
      if (!a) return;
      var id = decodeURIComponent((a.getAttribute('href') || '').replace(/^#/, ''));
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var headerEl = document.querySelector('.header-section, .site-header, header.shopify-section-group-header-group');
      var offset = (headerEl ? headerEl.offsetHeight : 0) + 12;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + id);
    });
  }

  function setupScrollSpy(toc, headings) {
    if (!('IntersectionObserver' in window) || !headings.length) return;
    var links = toc.querySelectorAll('.mdl-toc__link');
    var linkById = {};
    links.forEach(function (l) {
      var id = decodeURIComponent((l.getAttribute('href') || '').replace(/^#/, ''));
      if (id) linkById[id] = l;
    });

    var visible = new Set();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target.id);
        else visible.delete(entry.target.id);
      });
      var firstVisibleIdx = -1;
      headings.forEach(function (h, i) {
        if (visible.has(h.id) && firstVisibleIdx === -1) firstVisibleIdx = i;
      });
      links.forEach(function (l) { l.classList.remove('mdl-toc__link--active'); });
      if (firstVisibleIdx === -1) return;
      var activeId = headings[firstVisibleIdx].id;
      var activeLink = linkById[activeId];
      if (activeLink) activeLink.classList.add('mdl-toc__link--active');
    }, {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    });

    headings.forEach(function (h) { observer.observe(h); });
  }

  function init() {
    document.querySelectorAll('.mdl-toc').forEach(function (toc) {
      try { buildToc(toc); }
      catch (e) {
        if (window.console) console.warn('[mdl-toc] build failed:', e);
        try { toc.hidden = true; } catch (_) {}
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
